import * as React from "react"
import { memo } from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={29}
        height={23}
        fill="none"
        {...props}
    >
        <path
            fill="#83B81E"
            d="M22.72 0H5.718c-.78 0-1.43 0-1.962.044-.554.044-1.073.143-1.566.393a4.01 4.01 0 0 0-1.752 1.75C.188 2.68.088 3.2.044 3.755 0 4.286 0 4.935 0 5.715v11.171c0 .78 0 1.43.044 1.962.043.554.143 1.073.393 1.564a4.01 4.01 0 0 0 1.752 1.755c.491.249 1.012.347 1.565.393.53.043 1.181.043 1.957.043h17.016c.777 0 1.426 0 1.955-.044.555-.044 1.074-.143 1.565-.394a4.01 4.01 0 0 0 1.755-1.753c.249-.491.347-1.01.393-1.563.043-.53.043-1.18.043-1.957V5.71c0-.777 0-1.426-.044-1.957C28.35 3.2 28.25 2.68 28 2.189A4.01 4.01 0 0 0 26.247.437c-.491-.25-1.012-.35-1.566-.393C24.15 0 23.498 0 22.72 0ZM3.185 2.386c.13-.067.332-.129.75-.162.432-.035.992-.037 1.828-.037h16.917c.835 0 1.395 0 1.825.037.419.033.619.095.751.162.345.175.623.455.798.796.067.131.128.333.162.751.035.43.037.99.037 1.823v.077H2.188V5.76c0-.834 0-1.395.036-1.827.033-.418.095-.618.162-.75a1.83 1.83 0 0 1 .798-.797Zm2.285 12.197h5.833a1.094 1.094 0 0 1 0 2.188H5.47a1.094 1.094 0 1 1 0-2.188Z"
        />
    </svg>
)
const LogoCredit = memo(SvgComponent)
export default LogoCredit
